import { Defined } from '@/types/utils';
import { OperationResult } from 'urql';

import { ValidateEntryWithRulesQuery, ValidateEntryWithRulesQueryVariables } from '../api/query.generated';

export type ValidateResponse = Defined<
    OperationResult<ValidateEntryWithRulesQuery, ValidateEntryWithRulesQueryVariables>['data']
>;

export abstract class PicksValidationProcessor<Context> {
    protected nextProcessor?: PicksValidationProcessor<any>;

    constructor(protected readonly context: Context) {}

    setNextProcessor(next: PicksValidationProcessor<any>) {
        this.nextProcessor = next;
    }

    abstract process(data: ValidateResponse): void;
}

export class SimpleProcessor<T> extends PicksValidationProcessor<T> {
    constructor(protected readonly context: T, protected readonly fn: (data: any) => void) {
        super(context);
    }

    process(data: ValidateResponse): void {
        this.fn(data);
        this.nextProcessor?.process(data);
    }
}

export class ChainProcessors {
    static of(...args: PicksValidationProcessor<any>[]): PicksValidationProcessor<any> {
        if (args.length === 0) {
            throw new Error('Must pass at least one processor');
        }
        for (let i = 0; i < args.length - 1; i++) {
            args[i].setNextProcessor(args[i + 1]);
        }
        return args[0];
    }
}
